var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 6.5c0-1.734-.938-3.328-2.438-4.219a4.893 4.893 0 0 0-4.874 0A4.871 4.871 0 0 0 1.124 6.5a4.88 4.88 0 0 0 2.438 4.242c1.5.867 3.351.867 4.874 0 1.5-.89 2.438-2.484 2.438-4.242zM0 6.5a5.955 5.955 0 0 1 3-5.18 5.97 5.97 0 0 1 6 0 6.004 6.004 0 0 1 3 5.18 6.014 6.014 0 0 1-3 5.203 5.97 5.97 0 0 1-6 0A5.965 5.965 0 0 1 0 6.5zm5.438-3.188c0-.304.234-.562.562-.562a.57.57 0 0 1 .563.563v2.906L8.555 7.53c.258.188.328.54.164.797a.569.569 0 0 1-.797.14l-2.25-1.5a.577.577 0 0 1-.234-.468V3.312z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.124217ee73812bd0c607485c3355f9d9.svg";
export { ForwardRef as ReactComponent };